import { Node } from "@tiptap/core";

export default Node.create({
	name: "image",

	addOptions() {
		return {
			inline: true,
			textAlign: "left",
			alt: "My Image",
			width: 300,
			style: ""
		};
	},

	group: "block",

	draggable: true,

	addAttributes() {
		return {
			src: {
				default: null
			},
			alt: {
				default: "My Image"
			},
			width: {
				default: 300
			},
			textAlign: {
				default: "left"
			},
			style: {
				default: ""
			}
		};
	},

	parseHTML() {
		return [
			{
				tag: "div[data-custom-image]",
				getAttrs: dom => ({
					src: dom.querySelector("img").getAttribute("src"),
					alt: dom.querySelector("img").getAttribute("alt"),
					width: dom.querySelector("img").getAttribute("width"),
					textAlign: dom.style.textAlign || this.defaultOptions.textAlign
				})
			},
			{
				tag: "img",
				priority: 1001,
				getContent: dom => {
					const img = dom.cloneNode(true);
					if (!img.getAttribute("alt")) img.setAttribute("alt", this.defaultOptions.alt);
					if (!img.getAttribute("width"))
						img.setAttribute("width", this.defaultOptions.width);

					const parentDiv = document.createElement("div");
					parentDiv.setAttribute("data-custom-image", "true");

					const resizeContainer = document.createElement("div");
					resizeContainer.classList.add("image-resize-container");
					resizeContainer.style.maxWidth = "100%";
					resizeContainer.style.height = "auto";
					resizeContainer.style.width =
						parseInt(img.getAttribute("width") || this.options.width) + "px";
					resizeContainer.style.display = "inline-block";
					resizeContainer.appendChild(img);
					parentDiv.appendChild(resizeContainer);
					resizeContainer.classList.add("image-reference");

					const updateImageWidth = () => {
						const width = resizeContainer.style.width || resizeContainer.clientWidth;
						// Update image width using the custom command
						this.editor
							.chain()
							.setImageWidth(`${parseInt(width)}`)
							.run();
					};

					// Update image width when the mouse is released after resizing
					const onMouseUp = () => {
						updateImageWidth();
						//window.removeEventListener("mouseup", onMouseUp);
					};

					resizeContainer.addEventListener("mousedown", () => {
						window.addEventListener("mouseup", onMouseUp);
					});

					resizeContainer.addEventListener("click", () => {
						window.addEventListener("mouseup", onMouseUp);
					});

					return parentDiv.outerHTML;
				},
				getAttrs: dom => ({
					src: dom.getAttribute("src"),
					alt: dom.getAttribute("alt"),
					width: dom.getAttribute("width"),
					textAlign: "left",
					style: dom.getAttribute("style")
				})
			}
		];
	},

	renderHTML({ node }) {
		const container = document.createElement("div");
		container.setAttribute("data-custom-image", "true");
		container.style.textAlign = node.attrs.textAlign;

		const resizeContainer = document.createElement("div");
		resizeContainer.classList.add("image-resize-container");
		resizeContainer.style.maxWidth = "100%";
		resizeContainer.style.width = parseInt(node.attrs.width || this.options.width) + "px";
		resizeContainer.style.height = "auto";
		resizeContainer.style.display = "inline-block";

		// Function to update image width based on container width
		const updateImageWidth = () => {
			const width = resizeContainer.style.width || resizeContainer.clientWidth;
			// Update image width using the custom command
			this.editor
				.chain()
				.setImageWidth(`${parseInt(width)}`)
				.run();
		};

		// Update image width when the mouse is released after resizing
		const onMouseUp = () => {
			updateImageWidth();
			//window.removeEventListener("mouseup", onMouseUp);
		};

		resizeContainer.addEventListener("mousedown", () => {
			window.addEventListener("mouseup", onMouseUp);
		});

		resizeContainer.addEventListener("click", () => {
			window.addEventListener("mouseup", onMouseUp);
		});

		const imgElement = document.createElement("img");
		resizeContainer.classList.add("image-reference");
		imgElement.src = node.attrs.src;
		imgElement.alt = node.attrs.alt;
		imgElement.width = node.attrs.width || this.options.width;
		imgElement.style = node.attrs.style || this.options.style;

		container.appendChild(resizeContainer);
		resizeContainer.appendChild(imgElement);

		return container;
	},

	addCommands() {
		return {
			setImage:
				({ src, alt, width, height, textAlign }) =>
				({ commands }) => {
					return commands.insertContent({
						type: this.name,
						attrs: {
							src,
							alt,
							width,
							height,
							textAlign
						}
					});
				},
			setTextAlign:
				textAlign =>
				({ commands }) =>
					commands.updateAttributes(this.name, { textAlign }),
			setImageWidth:
				width =>
				({ tr, commands }) => {
					tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos) => {
						if (node.isAtom && node.type.name === "image") {
							tr = tr.setNodeMarkup(pos, null, { ...node.attrs, width });
							return false;
						}
						return true;
					});
					return commands;
				}
		};
	}
});
